import React from 'react';
import { useSelector } from 'react-redux';
import trashSVG from '@plone/volto/icons/delete.svg';
import { Icon } from '@plone/volto/components';

const DeleteContentToolbar = () => {
  const content = useSelector((state) => state?.content);
  const actions = useSelector((state) => state.actions?.actions ?? {});

  // check if current content is a deleteable contenttype
  const allowedContenttypes = [
    'News Item',
    'File',
    'Image',
    'Wiki',
    'Document',
  ];
  // routes without content, such as /controlpanel/users after /edit-user,
  // have no content data (#22806)
  const currentContenttype = content?.data?.['@type'];
  const contenttypeDeletable = allowedContenttypes.includes(currentContenttype);

  // check if current user has the permission to delete the current content
  var hasDeletePermission = false;
  if (actions?.object_buttons?.find((action) => action.id === 'delete')) {
    hasDeletePermission = true;
  }

  return (
    <>
      {contenttypeDeletable && hasDeletePermission ? (
        <div id={'delete-button'}>
          <a href={content.data['@id'] + '/delete'}>
            <Icon name={trashSVG} size="30px" />
          </a>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default DeleteContentToolbar;
